export const IS_NOT_EMPTY = (stringToCheck: any): boolean => {
	return !!(
		stringToCheck != undefined &&
		stringToCheck != null &&
		(typeof stringToCheck === 'string' || stringToCheck instanceof String) &&
		stringToCheck.length > 0
	);
};

export const IS_EMPTY = (stringToCheck: any): boolean => {
	return !IS_NOT_EMPTY(stringToCheck);
};

export const CAMEL_CASE = (str: any): string => {
	if (IS_NOT_EMPTY(str)) {
		return str
			.toLowerCase()
			.split(' ')
			.filter((word) => IS_NOT_EMPTY(word))
			.map((word) => {
				return word[0].toUpperCase() + word.substr(1);
			})
			.join(' ');
	}
	return '';
};

export const TITLE_CASE = (str: any): string => {
	if (IS_NOT_EMPTY(str)) {
		return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
	}
	return str;
};

export const EQUALS_IGNORE_CASE = (stringToCompare: any, originalString: any): boolean => {
	let result = false;
	if (
		IS_NOT_EMPTY(stringToCompare) &&
		IS_NOT_EMPTY(originalString) &&
		stringToCompare.toLowerCase() === originalString.toLowerCase()
	) {
		result = true;
	}
	return result;
};

export const EXTRACT_DATE_STRING = (v: unknown): string | null => {
	if (v == null) return null;
	const s = String(v).trim().toLowerCase();
	if (!s || s === 'null' || s === 'undefined') return null;

	// take the first segment if something like "20251006080000 - 20251006130000"
	const first = s.split('-')[0].trim();

	// keep only digits, then accept 8 (YYYYMMDD) or 14 (YYYYMMDDHHmmss)
	const digits = first.replace(/\D/g, '');
	if (digits.length === 14 || digits.length === 8) return digits;

	return null;
};
